import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../Components/Header"

const Recharge = () => {
  const [deviceIds, setDeviceIds] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    axios.get("/api/devices")
      .then(response => {
        setDeviceIds(response.data);
        console.log(response.data)
      })
      .catch(error => {
        console.error("Error fetching device IDs:", error);
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      device_id: selectedDevice,
      start_date: startDate,
      end_date: endDate,
    };
    axios.put("/api/Recharge/device", payload)
      .then(response => {
        alert("Recharge data submitted successfully!");
      })
      .catch(error => {
        alert("Submission failed.");
        console.error(error);
      });
  };

  return (
    <>
    <Header/>
    <div className="max-w-md mx-auto mt-10 p-4 border rounded shadow">
      <h2 className="text-xl font-bold mb-4">Recharge Form</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1 font-medium">Device ID:</label>
          <select
            value={selectedDevice}
            onChange={(e) => setSelectedDevice(e.target.value)}
            className="w-full border p-2 rounded"
            required
          >
            <option value="">-- Select Device --</option>
            {deviceIds.map(device => (
                <option key={device}>{device.device_id}</option>
                ))}
          </select>
        </div>

        <div>
          <label className="block mb-1 font-medium">Start Date:</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="w-full border p-2 rounded"
            required
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">End Date:</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="w-full border p-2 rounded"
            required
          />
        </div>

        <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700">
          Submit
        </button>
      </form>
    </div>
    </>
  );
};

export default Recharge;
